import { HttpRoutes } from 'utils/constant';

import { format } from '../utils';

export const getTitleSalaryStatesMapFileUrl = (title = '') => {
  const encodedTitle = encodeURIComponent(title);
  return `${format(HttpRoutes.getSalaryStatesMapForTitle, { encodedTitle })}.svg`;
};

export const getTitleLocationStatesMapFileUrl = (title = '') => {
  const encodedTitle = encodeURIComponent(title);
  return `${format(HttpRoutes.getLocationStatesMapForTitle, { encodedTitle })}.svg`;
};

export const getTitleJobOpeningsStatesMapFileUrl = (title = '') => {
  const encodedTitle = encodeURIComponent(title);
  return `${format(HttpRoutes.getDemandStatesMapForTitle, { encodedTitle })}.svg`;
};

export const getMajorSalaryStatesMapFileUrl = (major = '') => {
  const encodedMajor = encodeURIComponent(major);
  return `${format(HttpRoutes.getSalaryStatesMapForMajor, { encodedMajor })}.svg`;
};
